import { render } from "./PageBreadcrumbs.vue?vue&type=template&id=bcfbac54"
import script from "./PageBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./PageBreadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__